var React = require('react');

function Coffee (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3.33301 9C3.33301 16.2 6.44412 18 7.99967 18H11.333C13.1468 18 15.9727 16.217 15.9995 9.10201C15.9997 9.04678 15.9591 9 15.9038 9H6.66634M17.9997 9C21.9997 9 21.9997 15 17.9997 15H14.9997","stroke":"#2B1F2E","strokeWidth":"1.5","strokeLinecap":"round","key":0}),React.createElement("path",{"d":"M3 19C3 20 4 21 5 21C8 21 11.7042 21 16 21C17 21 18 20 18 19","stroke":"#2B1F2E","strokeWidth":"1.5","strokeLinecap":"round","key":1})]);
}

Coffee.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Coffee;

Coffee.default = Coffee;
